export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/FollowLinkArrow.91f7c556.svg","height":28,"width":24,"blurWidth":0,"blurHeight":0};